import Folder from 'records/Folder';
import {javaApiFor} from '../api';
import {List} from 'immutable';

const api = javaApiFor('/api/folders');

export default {
  fetchFolders() {
    return api
      .getJson('/', {params: {includeUnviewedCounts: true}})
      .then(folders => List(folders).map(folder => new Folder(folder)));
  },
  createFolder(folder) {
    return api.postJson('/', folder.toJS()).then(folder => new Folder(folder));
  },
  deleteFolder(folderId) {
    return api.delete(`${folderId}`);
  },
  emptyTrash() {
    return api.delete(`/trash/items`);
  },
};
